<div>
  @if (displayLoadingBanner()) {
    <div class="dialog-loading-banner">
      <span>{{ "Selfservice.IP.Waiting" | translate }}</span>
    </div>
  }
  <div class="title-flex">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/port.svg" class="purple"></svg-icon>
      @if (isIp()) {
        <span>{{ "ServiceElement.PortInternet" | translate }}</span>
      }
      @if (isL2Vpn() || isL3Vpn()) {
        <span>{{ "ServiceElement.ConnectedPorts" | translate }}</span>
      }
      @if (isFw()) {
        <span>{{ "ServiceElement.ConnectedNetworks" | translate }}</span>
      }
    </h3>
    @if (auth.isSelfServiceEnabled) {
      @if (isIp() && !firewallEnabled()) {
        <modify-ip-button
          [subscription]="service()"
          [isInfrastructureDelegate]="isInfrastructureDelegate()"
          (clicked)="openSelfserviceDialog($event)"
        />
      }
      @if (showModifyOptions) {
        <modify-l2vpn-fw-button
          [subscription]="service()"
          [isInfrastructureDelegate]="isInfrastructureDelegate()"
          (clicked)="openSelfserviceDialog($event)"
        />
      }
    }
  </div>

  @if (hasServices()) {
    <div class="card card--no-padding tabs">
      <tabbed-detail-navigation [tabs]="tabs()" [(activeTabIndex)]="activeTabIndex" />

      <div class="tabs__content">
        <div class="tabs__grid">
          @for (serviceSummary of serviceSummaries(); track $index) {
            <div class="tabs__grid-item">
              <!-- TODO: create type specific summaries to simplify this code -->
              <service-summary
                [service]="serviceSummary.port ? serviceSummary.port : serviceSummary"
                [subscriptionInstanceId]="serviceSummary.subscriptionInstanceId"
                [vlanranges]="serviceSummary.vlanrange ? [serviceSummary.vlanrange] : []"
                [showTraffic]="showTraffic()"
                [showTrafficButton]="
                  (
                    (serviceSummary.product
                      && (serviceSummary.product.type === 'L2VPN' || serviceSummary.product.type === 'L3VPN'))
                    || serviceSummary.port
                    || serviceSummary.l2Endpoints
                    || serviceSummary.l3Endpoints
                  ) ?
                    true
                  : false
                "
                [forceTrafficBottom]="hasConfigurationDetails()"
                style="width: 100%"
              />
            </div>
          }

          @if (hasConfigurationDetails()) {
            <div class="tabs__grid-item">
              <configuration-details
                [configurationDetails]="configurationDetails()"
                [isInfrastructureDelegate]="isInfrastructureDelegate()"
                [firewallEnabled]="firewallEnabled()"
                (clicked)="openSelfserviceDialog($event)"
              />
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="card card--no-padding">
      <empty-state [title]="'ServiceElement.NoConnectedNetworks' | translate" [icons]="['ip', 'l2vpn']"></empty-state>
    </div>
  }
</div>
